export default "__VITE_ASSET__vr1HJSsc__"